import { Link } from 'react-router-dom'
import { Icon } from '@/design-system'
import { useMediaUrl } from '@/hooks/useMediaUrl'
import { catRefName, formatDistance } from '@/utils/format'
import type { NearbyCat } from '@/types/models'

function NearbyRow({ cat }: { cat: NearbyCat }) {
  const url = useMediaUrl(cat.cover_media_id, 'thumb')
  const named = Boolean(cat.name)

  return (
    <Link className="nearby__row" to={'/gato/' + cat.cat_id + '?de=' + cat.owner_id}>
      {url ? (
        <img className="nearby__thumb" src={url} alt="" loading="lazy" decoding="async" />
      ) : (
        <span className="nearby__thumb nearby__thumb--empty">
          <Icon name="cat" size={20} />
        </span>
      )}

      <span className="nearby__main">
        <span className={'nearby__name' + (named ? '' : ' nearby__name--unnamed')}>
          {catRefName(cat.name, cat.catalog_no)}
        </span>
        <span className="nearby__owner">@{cat.owner_username}</span>
      </span>

      {/*
        An exact distance is only ever shown for cats whose true position the
        viewer is entitled to. For everyone else we say where, not how far —
        a metre count would leak the coordinate by arithmetic. (§18)
      */}
      {cat.loc_precision === 'exact' && cat.metres != null ? (
        <span className="nearby__distance">{formatDistance(cat.metres)}</span>
      ) : (
        <span className="nearby__area">Por {cat.area_label ?? 'esta zona'}</span>
      )}
    </Link>
  )
}

export function NearbyList({ cats }: { cats: NearbyCat[] }) {
  return (
    <div className="nearby__list">
      {cats.map((cat) => (
        <NearbyRow key={cat.cat_id + cat.owner_id} cat={cat} />
      ))}
    </div>
  )
}
